import { useState, useContext, Fragment } from 'react';  
import { Dialog, Transition } from '@headlessui/react';  
import { AuthContext } from '../contexts/AuthContext';  
import { useNavigate } from 'react-router-dom';  
import { XMarkIcon } from '@heroicons/react/24/solid';  
  
// Constants  
const API_KEY = 'fea70320-ccf3-493b-b43b-d75f9235f0d6';  
const APPLICATION_NAME = 'MemeBot';  
const API_URL = 'https://authentication.api.ceo.ai';  
  
export default function Login() {  
  const [isDialogOpen, setIsDialogOpen] = useState(false);  
  const [dialogMessage, setDialogMessage] = useState('');  
  const { login } = useContext(AuthContext);  
  const navigate = useNavigate();  
  
  // Store OAuth state in localStorage to verify callback  
  const generateOAuthState = () => {  
    const state = Math.random().toString(36).substring(7);  
    localStorage.setItem('oauth_state', state);  
    return state;  
  };  
  
  const handleXLogin = async () => {  
    try {  
      // Initial request to get OAuth URL  
      const response = await fetch(`${API_URL}`, {  
        method: 'POST',  
        headers: {  
          'Content-Type': 'application/json',  
        },  
        body: JSON.stringify({  
          authType: 'twitter',  
          apiKey: API_KEY,  
          applicationName: APPLICATION_NAME,  
          state: generateOAuthState()  
        })  
      });  
  
      const data = await response.json();  
        
      if (data.data?.url) {  
        // Redirect to X/Twitter OAuth page  
        window.location.href = data.data.url;  
      } else {  
        setDialogMessage('Failed to initialize X login');  
        setIsDialogOpen(true);  
      }  
    } catch (error) {  
      setDialogMessage('An error occurred during login');  
      setIsDialogOpen(true);  
    }  
  };  
  
  return (  
    <div className="flex min-h-full flex-1 items-center justify-center px-4 py-12 sm:px-6 lg:px-8">  
      <div className="w-full max-w-sm space-y-10">  
        <div>  
          <img  
            className="mx-auto h-10 w-auto"  
            src="/your-logo.png"  
            alt="Your Logo"  
          />  
          <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">  
            Sign in to your account  
          </h2>  
        </div>  
  
        <div className="space-y-6">  
          <button  
            onClick={handleXLogin}  
            className="flex w-full justify-center items-center gap-3 rounded-md bg-black px-3 py-1.5 text-sm font-semibold leading-6 text-white hover:bg-gray-800"  
          >  
            <XMarkIcon className="h-5 w-5" />  
            Continue with X  
          </button>  
        </div>  
  
        <Transition appear show={isDialogOpen} as={Fragment}>  
          <Dialog   
            as="div"   
            className="relative z-10"   
            onClose={() => setIsDialogOpen(false)}  
          >  
            {/* Dialog components from your example */}  
            {/* ... */}  
          </Dialog>  
        </Transition>  
      </div>  
    </div>  
  );  
}  